/**
 * 根据生日计算年龄
 */
export function rAge(birth) {
    if(birth == null || birth == '' || birth == undefined) {
        return '';
    }
    let dBirth = new Date(birth)
    let dNowDate = new Date()
    let tampBirth = Date.parse(dBirth)
    let tampNow = Date.parse(dNowDate)
    let dayDiff = Math.ceil((tampNow - tampBirth) / (60 * 60 * 1000 * 24))
    let age = 0
    let yAge = Math.floor(dayDiff / 365)
    let yMod = dayDiff % 365
    let mMod = Math.floor(yMod / 30)
    let dMod = Math.floor(dayDiff % 365 % 30)
    // age = `${yAge}岁${mMod}月${dMod}天`
    // age = `${yAge}岁`
    age = yAge
    return age
}

